import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Page crashed:', error, info.componentStack);
  }

  // Clears a caught error when navigating away, WITHOUT forcing React to
  // unmount/remount the whole subtree (a `key` prop would do that, and can
  // itself crash React mid-navigation — this only touches local state).
  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="empty-state">
          <p>Something went wrong loading this page.</p>
          <p className="text-muted" style={{ fontSize: 12, marginTop: 8 }}>{this.state.error.message}</p>
          <button className="btn btn-primary" style={{ marginTop: 16 }}
            onClick={() => { this.setState({ error: null }); this.props.onRetry?.(); }}>
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
